module.exports = __webpack_public_path__ + "media/images/emblems/Brot-Plamboz-coat_of_arms-a66a46a233e96884f9caa9db7af1a193.svg";